var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF4Ly07Ldn7194Ciimghrumv3L(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    id: "like-creation-large",
    "data-supported-dps": "48x48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.39 22H10.13c-2 0-3.2 2.11-3.12 3.92a3.23 3.23 0 003.3 3h.57a2.75 2.75 0 00-2.69 2.84 2.84 2.84 0 002.62 2.83 2.83 2.83 0 001.18 5 2.9 2.9 0 00-.29 2 3 3 0 003 2.24h8.18a13.06 13.06 0 003.17-.41l5.13-1.5c.3-.09 4.74 0 6.74 0 3.57-.14 4.53-16.52 0-16.52 0 0-1.65.06-2 0-.16 0-.52-.68-1.41-1.64l-.08-.1c-1.3-1.41-2.78-3.23-3.82-4.26-2.53-2.48-4.63-4.61-6.09-7.84C23.8 9.83 23.71 9 22 9a2.77 2.77 0 00-2.38 2.9 27.06 27.06 0 00.38 2.85c.63 3.38 3.43 7.08 3.51 7.25",
    fill: "#378fe9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.49 23H10.13c-2 0-3.21 1.19-3.13 3a3.22 3.22 0 003.31 3h.57a2.77 2.77 0 00-2.69 2.84 2.84 2.84 0 002.62 2.83v0a2.83 2.83 0 001.18 5 2.9 2.9 0 00-.29 2 3 3 0 003 2.24h8.18a13.06 13.06 0 003.17-.41l5.13-1.5c.3-.09 4.74 0 6.74 0 3.57-.14 4.53-16.52 0-16.52 0 0-1.65.06-2 0-.16 0-.52-.68-1.41-1.64l-.08-.1c-1.3-1.41-2.78-3.23-3.82-4.26-2.53-2.48-4.63-4.6-6.09-7.84C23.8 9.87 23.71 9 22 9a2.66 2.66 0 00-2.38 2.9 27.06 27.06 0 00.38 2.85c.63 3.38 3.43 8 3.51 8.21z",
    fill: "none",
    stroke: "#004182",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF4Ly07Ldn7194Ciimghrumv3L);
export default __webpack_public_path__ + "static/media/f4ly07ldn7194ciimghrumv3l.f15f30d3a97512b971837cb642f2ab8b.svg";
export { ForwardRef as ReactComponent };